// eslint-disable-next-line import/no-anonymous-default-export
export default function () {
  const fallbackLocation = {
    lat: 6.5244,
    lng: 3.3792,
  };

  const getPosition = (options) =>
    new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resolve, reject, options);
    });

  return new Promise((resolve) => {
    if (!("geolocation" in navigator)) {
      resolve(fallbackLocation);
      return;
    }

    const resolveLocation = async () => {
      try {
        const position = await getPosition({
          enableHighAccuracy: false,
          timeout: 20000,
          maximumAge: 60000,
        });
        resolve({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        });
        return;
      } catch (normalError) {
        try {
          const position = await getPosition({
            enableHighAccuracy: true,
            timeout: 30000,
            maximumAge: 0,
          });
          resolve({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          });
          return;
        } catch (highAccuracyError) {
          console.warn("Geolocation unavailable, using fallback location.", {
            normalError,
            highAccuracyError,
          });
        }
      }

      // Final fallback if geolocation is blocked, denied, or timed out.
      resolve(fallbackLocation);
    };

    resolveLocation();
  });
}